var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class RGPDConsent extends Component {
    constructor() {
        super('RGPDConsent', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            const grpgClosed = localStorage.getItem('ab-grpg-closed');
            if (grpgClosed != 'true')
                $('#ab-rgpb-consent').removeClass('d-none');
            $('#ab-rgpd-btn-configure').on('click', (event) => {
                event.preventDefault();
                $('#ab-rgpb-consent-introduction').addClass('d-none');
                $('#ab-rgpb-consent-details').removeClass('d-none');
            });
            $('#ab-rgpb-close, #ab-rgpd-btn-agree, #ab-rgpd-btn-close').on('click', (event) => {
                event.preventDefault();
                $('#ab-rgpb-consent').addClass('d-none');
                localStorage.setItem('ab-grpg-closed', 'true');
            });
            this.success();
        });
    }
}
